module.exports = __webpack_public_path__ + "static/media/Lens-Fresh Gray_diameter.ab5477dd.png";